import { LOGOUT, WHOAMI } from '@/services/api/auth'
import { client } from '@/services/apolloclient'
import { getFeaturehubData } from '@/services/rest-api-featurehub/feature/feature'

export const state = {
  whoami: null,
  featureFlag: null,
}

export const mutations = {
  setResource(state, resource) {
    state.whoami = resource
  },
  setFeatureFlag(state, featureFlag) {
    state.featureFlag = featureFlag
  },
}

export const getters = {
  hasAccess: (state) => (scope) => {
    if (state.whoami && state.whoami?.scopes.length == 0) {
      return true
    }
    if (!Array.isArray(scope)) {
      return state.whoami?.scopes.includes(scope)
    }
    for (let i = 0; i < scope.length; i++) {
      if (state.whoami?.scopes.includes(scope[i])) {
        return true
      }
    }

    return false
  },
  hasAccessAll: (state) => (scope) => {
    if (state.whoami && state.whoami?.scopes.length == 0) {
      return true
    }
    if (!Array.isArray(scope)) {
      return state.whoami?.scopes.includes(scope)
    }
    for (let i = 0; i < scope.length; i++) {
      if (!state.whoami?.scopes.includes(scope[i])) {
        return false
      }
    }
    return true
  },
  getFeatureFlagData: (state) => (featureFlag) => {
    if (!Array.isArray(state.featureFlag)) return null
    return state.featureFlag?.find((feature) => feature.key === featureFlag)
  },
  getFeatureFlagValue: (state) => (featureFlag) => {
    const feature = state.featureFlag?.find((feature) => feature.key === featureFlag)
    if (!feature) return false

    const { value, type } = feature

    if (type === 'JSON') return JSON.parse(value)
    if (type === 'BOOLEAN') return value
    if (type === 'NUMBER') return Number(value)

    return value
  },
}

export const actions = {
  init(context) {
    return client
      .query({
        fetchPolicy: 'no-cache',
        manual: true,
        query: WHOAMI,
      })
      .then(({ data }) => {
        context.commit('setResource', data.whoami.whoami)
        return data.whoami.whoami
      })
      .catch(() => {
        return {}
      })
  },
  logout() {
    return client
      .mutate({
        fetchPolicy: 'no-cache',
        mutation: LOGOUT,
      })
      .then(({ data }) => {
        return data
      })
      .catch((e) => {
        console.error(e)
      })
  },
  async getFeatureFlag(context) {
    const res = await getFeaturehubData()
    if (!res) return
    const featureFlag = []
    res.forEach((data) => featureFlag.push(...data.features))
    context.commit('setFeatureFlag', featureFlag)
  },
}
